import IntentProjectsTableNameCell from "./NameCell";
import IntentProjectsTableDescriptionCell from "./DescriptionCell";
import IntentProjectsTableSpaceCell from "./SpaceCell";
import IntentProjectsTableCreatedAtCell from "./CreatedAtCell";
import IntentProjectsTableLastResourcesUpdatedAtCell from "./LastResourcesUpdatedAtCell";
import IntentProjectsTableCreatedByCell from "./CreatedByCell";
import IntentProjectsTableRowActionsCell from "./RowActionsCell";
import { INTENT_PROJECTS_COLUMN_ID } from "../constants";
import IntentProjectsTableLockedCell from "./LockedCell";

export const INTENT_PROJECTS_TABLE_CELLS = {
  [INTENT_PROJECTS_COLUMN_ID.NAME]: IntentProjectsTableNameCell,
  [INTENT_PROJECTS_COLUMN_ID.DESCRIPTION]: IntentProjectsTableDescriptionCell,
  [INTENT_PROJECTS_COLUMN_ID.SPACE]: IntentProjectsTableSpaceCell,
  [INTENT_PROJECTS_COLUMN_ID.CREATED_AT]: IntentProjectsTableCreatedAtCell,
  [INTENT_PROJECTS_COLUMN_ID.LAST_RESOURCES_UPDATED_AT]:
    IntentProjectsTableLastResourcesUpdatedAtCell,
  [INTENT_PROJECTS_COLUMN_ID.CREATED_BY]: IntentProjectsTableCreatedByCell,
  [INTENT_PROJECTS_COLUMN_ID.LOCKED]: IntentProjectsTableLockedCell,
  [INTENT_PROJECTS_COLUMN_ID.DROPDOWN]: IntentProjectsTableRowActionsCell,
};
